import { render, staticRenderFns } from "./customerWxOrder.vue?vue&type=template&id=40eb6429&scoped=true"
import script from "./customerWxOrder.vue?vue&type=script&lang=js"
export * from "./customerWxOrder.vue?vue&type=script&lang=js"
import style0 from "./customerWxOrder.vue?vue&type=style&index=0&id=40eb6429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb6429",
  null
  
)

export default component.exports